import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FieldsMatch = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 4C3 2.89543 3.89543 2 5 2H18C19.1046 2 20 2.89543 20 4V5.28988C19.3663 5.10128 18.695 5 18 5C14.4735 5 11.5561 7.60771 11.0709 11H5C3.89543 11 3 10.1046 3 9V4ZM11.0709 13H5C3.89543 13 3 13.8954 3 15V20C3 21.1046 3.89543 22 5 22H18C19.1046 22 20 21.1046 20 20V18.7101C19.3663 18.8987 18.695 19 18 19C14.4735 19 11.5561 16.3923 11.0709 13Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5782 8.50762C20.6702 7.57747 19.4025 7 18 7C15.2386 7 13 9.23858 13 12C13 14.7614 15.2386 17 18 17C20.7614 17 23 14.7614 23 12C23 11.3786 22.8866 10.7837 22.6795 10.2347L18.7071 14.2071C18.3166 14.5976 17.6834 14.5976 17.2929 14.2071L15.7929 12.7071C15.4024 12.3166 15.4024 11.6834 15.7929 11.2929C16.1834 10.9024 16.8166 10.9024 17.2071 11.2929L18 12.0858L21.5782 8.50762Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
